import React from 'react';
type PageSectionProps = {
  children: React.ReactNode;
  labelledBy?: string;
  label?: string;
  id?: string;
  className?: string;
};
export function PageSection({
  children,
  labelledBy,
  label,
  id,
  className = ''
}: PageSectionProps) {
  return <section id={id} aria-labelledby={labelledBy} aria-label={label} className={`border-t border-zinc-800 px-5 py-12 md:px-12 md:py-14 ${className}`} data-id="element-46" data-mp="1vuhmemvlubf4">
      {children}
    </section>;
}